import { BasePostApi, UploadBaseApi, BodyRequest, Apiv1BodyRequest } from '@/core/apis/base-api'

// 获取订阅消息模板ID
export class GetSubscribeApi extends BasePostApi {
  protected url = '/api/Common/getSubscribe'
}

// 联系商家或骑手保存日志
export class SaveCallApi extends BasePostApi {
  protected url = '/api/order/saveCallRecord'

  set type(v: number) {
    this.data = {
      ...this.data,
      call_type: v,
    }
  }

  set oid(v: number) {
    this.data = {
      ...this.data,
      order_id: v,
    }
  }
}

// 获取用户地理位置的名称
export class GoogleAddressApi extends BasePostApi {
  protected url = '/index.php/wap/getAddress'

  set lat(v: number) {
    this.data = {
      ...this.data,
      lat: v,
    }
  }

  set lng(v: number) {
    this.data = {
      ...this.data,
      lng: v,
    }
  }
}

// 热门搜索关键词
export class HotKeywordApi extends BasePostApi {
  protected url = '/apiv1/app.Search/getHotWords'

  // 所属搜索模块:1=首页,2=商城,3=外卖
  set type(v: number) {
    this.data = {
      ...this.data,
      type: v,
    }
  }
}

// 热门搜索榜单
export class HotSearchRecommendApi extends BasePostApi {
  protected url = '/apiv1/app.Search/getSearchRecommendList'

  // 所属搜索模块:1=首页,2=商城,3=外卖
  set type(v: number) {
    this.data = {
      ...this.data,
      type: v,
    }
  }
}

// 模糊搜索
export class VagueSearchApi extends BasePostApi {
  protected url = '/apiv1/app.search/searchWords'

  set type(v: string) {
    this.data = {
      ...this.data,
      biz_type: v,
    }
  }

  set keyword(v: string) {
    this.data = {
      ...this.data,
      keyword: v,
    }
  }
}

// 首页搜索
export class IndexSearchApi extends BasePostApi {
  protected url = '/apiv1/app.Search/index'

  set type(v: string) {
    this.data = {
      ...this.data,
      biz_type: v,
    }
  }

  set keyword(v: string) {
    this.data = {
      ...this.data,
      keyword: v,
    }
  }

  set page(v: number) {
    this.data = {
      ...this.data,
      page: v,
    }
  }

  set sortParams(v: AnyObject) {
    this.data = {
      ...this.data,
      ...v,
    }
  }

  set adrParams(v: AnyObject) {
    this.data = {
      ...this.data,
      ...v,
    }
  }
}

// 搜索全部筛选
export class SearchSortConfigApi extends BasePostApi {
  protected url = '/apiv1/app.search/config'
}

// 绑定手机号码
export class BindMobileApi extends BasePostApi {
  protected url = '/api/tuser/bindMobile'

  set code(v: string) {
    this.data = {
      ...this.data,
      code: v,
    }
  }

  set mobile(v: string) {
    this.data = {
      ...this.data,
      mobile: v,
    }
  }
}

// 绑定手机号码V2
export class BindMobileNewApi extends BodyRequest {
  protected url = '/apiv2/uc.passport_compat/bindMobile'

  set code(v: string) {
    this.data = {
      ...this.data,
      code: v,
    }
  }

  set mobile(v: string) {
    this.data = {
      ...this.data,
      mobile: v,
    }
  }
}

// 广告弹框
export class AdvPopApi extends BasePostApi {
  protected url = '/api/index/getAdvPopUp'

  // 1=>首页弹框广告，2=>商城频道弹窗广告，3=>外卖频道弹窗广告，4=>淘淘频道弹窗广告，5=>APP个人中心广告, 11='我的页面'弹窗
  set type(v: number) {
    this.data = {
      ...this.data,
      type: v,
    }
  }
}

// 图片上传
export class UploadImg extends UploadBaseApi {
  protected url = '/api/upload/media'

  set type(v: string) {
    this.data = {
      ...this.data,
      type: v,
    }
  }

  set file(v: any) {
    this.filePath = v
  }

  set bucket(v: string) {
    this.data = {
      ...this.data,
      bucket: v,
    }
  }
}

// 语音验证码
export class VerificationCodeApi extends BasePostApi {
  protected url = '/api/member/verificationCode'

  set mobile(v: string) {
    this.data = {
      ...this.data,
      mobile: v,
    }
  }
}

// 获取微信scheme
export class GuideApi extends BasePostApi {
  protected url = '/apiv1/app.group/guide'
}

// 获取分享公共参数
export class getShareParamsApi extends BasePostApi {
  protected url = '/api/common/getShareParams'
  set setUrl(url: any) {
    this.data = {
      ...this.data,
      url,
    }
  }
}

// 自定义上报行为
export class ReportApi extends Apiv1BodyRequest {
  protected url = '/apiv1/app.report'

  constructor() {
    super()
    const params: AnyArray = []
    for (const key in this.data) {
      params.push(`${key}=${this.data[key]}`)
    }
    params.push(`sign=${this.generateSign(this.data)}`)
    this.urlParams = params.join('&')
    this.data = {}
    this.headers['content-type'] = 'application/json'
  }

  set param(param: object) {
    this.data = [param]
  }
}

// 合并订单列表
export class OrderListApi extends BasePostApi {
  protected url = '/apiv1/app.order/orderList'

  set page(v: number) {
    this.data = {
      ...this.data,
      page_index: v,
    }
  }

  set size(v: number) {
    this.data = {
      ...this.data,
      page_size: v,
    }
  }

  set status(v: number) {
    this.data = {
      ...this.data,
      order_status: v,
    }
  }

  set type(v: number) {
    this.data = {
      ...this.data,
      order_type: v,
    }
  }
}

export class NewerCoupons extends BasePostApi {
  protected url = '/api/takeout/getNewerCoupons'
}

// 小程序消息订阅
export class SubscribeApi extends BodyRequest {
  protected url = '/apiv2/uc.message/addAppletSubscribeRecord'

  // 类型:1=外卖订单,2=商城订单,3=优惠券
  set type(v: number) {
    this.data = {
      ...this.data,
      type: v,
    }
  }

  set oid(v: string) {
    this.data = {
      ...this.data,
      order_id: v,
    }
  }

  set openStatus(v: AnyObject) {
    this.data = {
      ...this.data,
      open_status: JSON.stringify(v),
    }
  }
}

// 记录广告访问
export class RecordAdvApi extends BasePostApi {
  protected url = '/api/index/recordPlatformAdvAccess'

  set id(v: string) {
    this.data = {
      ...this.data,
      adv_id: v,
    }
  }
}

// 获取下单赚积分卡片信息
export class GetScoreCardInfoApi extends BodyRequest {
  protected url = '/apiv2/uc.score/getLatestTask'

  set params(v: AnyObject) {
    this.data = {
      ...this.data,
      ...v,
    }
  }
}

// 领任务
export class LeadingTasksApi extends BodyRequest {
  protected url = '/apiv2/uc.score/receiveTask'

  set params(v: AnyObject) {
    this.data = {
      ...this.data,
      ...v,
    }
  }
}

// 获取区号列表
export class getAreaCodeApi extends BodyRequest {
  protected url = '/apiv2/uc.passport_compat/getCountryCodes'
}
